import { useWindowSize } from '@uidotdev/usehooks'
import type { ReactNode } from 'react'
import React from 'react'
import { GridSingleCellComponent } from '#src/components/GridSingleCellComponent.js'
import type { GridDuplexCell, GridSingleCell } from '#src/data/data.js'

interface Props {
  cell: GridDuplexCell
  galleryPath: string
}

export function GridDuplexCellComponent(props: Props): ReactNode {
  const { galleries } = props.cell
  const { galleryPath } = props
  const windowSize = useWindowSize()
  const width = windowSize.width || 0
  const isMobile = width <= 600

  const cells: GridSingleCell[] = galleries.map(gallery => {
    return {
      id: gallery.slug,
      gallery,
    }
  })

  const [cell1, cell2, cell3, cell4] = cells as [
    GridSingleCell,
    GridSingleCell,
    GridSingleCell,
    GridSingleCell,
  ]

  if (isMobile) {
    return (
      <>
        {cells.map(cell => (
          <GridSingleCellComponent key={cell.id} cell={cell} galleryPath={galleryPath} />
        ))}
      </>
    )
  }

  return (
    <>
      <div className="grid__duplex-col1">
        <GridSingleCellComponent
          className="grid__duplex-cell1"
          cell={cell1}
          galleryPath={galleryPath}
        />
        <GridSingleCellComponent
          className="grid__duplex-cell2"
          cell={cell2}
          galleryPath={galleryPath}
        />
      </div>

      <div className="grid__duplex-col2">
        <GridSingleCellComponent
          className="grid__duplex-cell3"
          cell={cell3}
          galleryPath={galleryPath}
        />
        <GridSingleCellComponent
          className="grid__duplex-cell4"
          cell={cell4}
          galleryPath={galleryPath}
        />
      </div>
    </>
  )
}
